import { render, staticRenderFns } from "./ContactPersonCreateForm.vue?vue&type=template&id=22cc1179"
import script from "./ContactPersonCreateForm.vue?vue&type=script&lang=js"
export * from "./ContactPersonCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports